const ProgresoItem = ({ label, completados, total }) => {
  const porcentaje = total > 0 ? Math.round((completados / total) * 100) : 0;

  // Asignar color dinámico según porcentaje
  let color = 'progress-error'; // rojo por defecto
  if (porcentaje >= 100) color = 'progress-success';
  else if (porcentaje >= 70) color = 'progress-info';
  else if (porcentaje >= 30) color = 'progress-warning';

  return (
    <div className="mb-4">
      <div className="flex justify-between mb-1">
        <span className="font-semibold text-gray-700">{label}</span>
        <span className="text-sm text-gray-600">{completados} de {total} ({porcentaje}%)</span>
      </div>
      <progress
        className={`progress ${color} w-full h-3`}
        value={completados}
        max={total}
      ></progress>
    </div>
  );
};

export default ProgresoItem;
